module.exports = __webpack_public_path__ + "img/potrait2.701a3827.jpg";